$(document).ready(function () {
    enableMoreDiv = true;
    $('.oesText').show();

    function formatState(state) {
        if (!state.id) {
            return state.text;
        }
        var $state = $(
            '<span style="background-image: url(https://static.delti.com/static/tirendo-ebon/common/images/fl-s.gif)" class="'+state.element.value.toLowerCase()+'" />' + state.text + '</span>'
        );
        return $state;
    };

    $(".custom-language-select").select2({
        templateResult: formatState,
        templateSelection: formatState
    });
});
